import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AngularFireStorage } from "@angular/fire/storage";
import { finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FilesService {
    constructor(private storage: AngularFireStorage) { }
    
    public async uploadFileAndGetLink(event) {
        var n = Date.now();
        const file = event.target.files[0];
        const filePath = `Images/${n}`;
        const fileRef = this.storage.ref(filePath);
        await this.storage.upload(`Images/${n}`, file);
        const link = await fileRef.getDownloadURL().toPromise();
        console.log("link",link);
        return link
      }
}